import { NodeSpec } from "prosemirror-model";
import { v4 as uuidV4 } from "uuid";

export const DEFAULT_LANGUAGE = "Plain Text";
export const DEFAULT_THEME = "xq-light";
export const DEFAULT_TITLE = "代码块";

export const code_block: NodeSpec = {
  group: "block",
  content: "text*",
  allowGapCursor: true,
  insertBlock: true,
  dragBlock: true,
  marks: "",
  attrs: {
    language: { default: DEFAULT_LANGUAGE }, // 语言
    theme: { default: DEFAULT_THEME }, // 皮肤
    title: { default: DEFAULT_TITLE }, // 标题
    isExpand: { default: true }, // 是否展开
    isCreate: { default: false }, // 是否刚被创建
    dataDiffId: { default: null },
  },
  parseDOM: [
    {
      tag: 'div[class="ct-code"]',
      preserveWhitespace: "full",
      getAttrs(dom: HTMLElement) {
        const titleDOM = dom.querySelector(".title");
        const languageDOM = dom.querySelector(".language");
        const dataDiffId = dom.getAttribute("data-diff-id");
        const {
          language = languageDOM
            ? languageDOM.getAttribute("data-language") || DEFAULT_LANGUAGE
            : DEFAULT_LANGUAGE,
          theme = DEFAULT_THEME,
          title = titleDOM
            ? titleDOM.getAttribute("data-title") || DEFAULT_TITLE
            : DEFAULT_TITLE,
        } = dom.dataset;
        let isExpand;
        if (dom.querySelector(".isNotExpand")) {
          isExpand = false;
        } else {
          isExpand = dom.getAttribute("data-expand") !== "false";
        }
        return { language, theme, title, isExpand, dataDiffId };
      },
    },
  ],
  toDOM(node) {
    const { language, theme, title, isExpand, dataDiffId } = node.attrs;
    const attrs = {
      class: "ct-code",
      spellcheck: "false",
      "data-language": language,
      "data-theme": theme,
      "data-title": title,
      "data-expand": isExpand,
      "data-diff-id": dataDiffId || `ct-diff-id-${uuidV4()}`,
    };
    return ["div", attrs, ["pre", {}, ["code", 0]]];
  },
};
